<template>
  <div class="row d-flex justify-content-center p-0 m-0">
    <b-card class="cardDash p-0 justify-content-end"> 
        <div class="d-flex justify-content-end"> 
          <h6 class="btn-close flo" @click="toDash">  </h6>  
        </div> 
    </b-card> 
  </div>
</template>

<script>
 
export default {
  name: 'ChatCard',
  data() {
    return {
      connected: false,
      messages: [], 
      newMessage: '',
      socket: null,
      username: '', 
      roomId: 'enem',
    };
  },
  created() {

    let token = localStorage.getItem('enem-token');

    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    this.username =  JSON.parse(jsonPayload).username
 
  },
 
  methods: { 
    toDash() { 
      this.$emit('toDash'); 
    }, 
  }
};
</script>

<style scoped>

.iframe-chat {
  height: 95%;
  width: 100%;
}
.cardDash {
  height: 90vh;
}
  
</style>